import styled from 'styled-components';

export const WrapperTimelineDate = styled.section`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 48px;
`;

export const WrapperDate = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 140px;
    border-radius: 20px;
    gap: 12px;
    background-color: ${({ theme }) => theme.colors.surface.high};
    border: 1px solid ${({ theme }) => theme.colors.border};
`;

export const Division = styled.div`
    width: 32px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.surface.low};
`;

export const Weekday = styled.span`
    font-family: 'Elza', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const ContainerDate = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

`;

export const Day = styled.span`
    font-family: MADE Outer Sans;
    font-size: 16px;
    font-weight: 700;
    line-height: 22.4px;
    text-align: center;
    color: ${({ theme }) => theme.colors.accent.primary};
    font-family: 'Elza', sans-serif;
`;

export const Month = styled.span`
    font-family: 'Elza', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: ${({ theme }) => theme.colors.accent.primary};
`;

export const Hour = styled.span`
    font-family: 'Elza', sans-serif;
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
    text-align: left;
    color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const VerticalLine = styled.div<{$isLastItem: boolean}>`
    position: absolute;
    display: ${({ $isLastItem }) => ($isLastItem ? 'none' : 'flex')};
    width: 1px;
    height: 100%;
    bottom: -130px;
    background-color: ${({ theme }) => theme.colors.border};
    z-index: -1;
`;
